/* Shared vocabulary for the follow-up board: the service filter options, the
   tone classes every badge and tile is coloured from, and the KPI tile itself.
   Kept in one place so a card, a column header and a summary tile can never
   drift into three different shades of the same idea. */

export const SERVICE_OPTIONS = [
  { value: "all", label: "All services" },
  { value: "afs", label: "Financial Statements" },
  { value: "assurance", label: "Audit / Review" },
  { value: "bookkeeping", label: "Bookkeeping" },
];

export const TONE_CLASSES = {
  teal: "border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)]",
  amber:
    "border-[color:var(--tt-warn-border)] bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)]",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  muted: "border-border bg-muted text-muted-foreground",
};

export const SummaryTile = ({ icon: Icon, label, value, hint, tone = "teal", testId }) => (
  <div data-testid={testId} className="rounded-lg border border-border bg-white px-4 py-3">
    <div className="flex items-start justify-between gap-3">
      <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-muted-foreground">
        {label}
      </p>
      <span
        className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border ${
          TONE_CLASSES[tone] || TONE_CLASSES.teal
        }`}
      >
        <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      </span>
    </div>
    <p className="mt-2 font-amount text-2xl font-bold leading-none text-foreground">{value}</p>
    {hint ? <p className="mt-1.5 text-[11px] text-muted-foreground">{hint}</p> : null}
  </div>
);
